import React, { useState } from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";
// hooks
import usePages from "@/hooks/usePages";
import useMenuItems from "@/hooks/useMenuItems";
// components
import RMDRLink from "@/components/RMDRLink";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    menuNameDescriptionLanguageVersion,
    outerNameDescriptionLanguageVersion, 
    pageNameDescriptionLanguageVersion, 
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
// interfaces
import TClientPageList from "@/cms/types/TClientPageList";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// types
import { TMainPageLayoutV2 } from "../type";
// enums
import EContentType from "@/cms/enums/EContentType";


const RenderComponent = ( props:any ) => {

    return (
        <div className="col-lg-2 col-md-6 col-sm-6">
            <div
                className="single-footer-widget ml-4 pl-5"
                data-aos="fade-in"
                data-aos-duration="1000"
                data-aos-delay="200"
            >
                <h3>{props.parentLanguageVersion?.name}</h3>
                {props.children}
            </div>
        </div>
    )

}

const RenderItems = (props:{ payload:TClientPageList[]|TClientMenuItemList[]|TClientMainPageItemList[]|null, languageVersionSelector:any, template?:TClientMainPageItemList }) => {

    if ( !isEmpty(props.payload) && props.payload ) {

        return (
            <ul className="list">
                {
                    props.payload.map((item:any) => {
                        const itemLanguageVersion = props.languageVersionSelector(item.languageVersions);
                        const itemRedirectUrl = redirectUrl(item.languageVersions);
                        const hasDestinationNavigation = props.template?.hasDestinationNavigation||item.hasDestinationNavigation;
                        const redirectType = props.template?.redirectType||item.redirectType;

                        return (
                            <li key={item.id}>
                                <RMDRLink
                                    text={itemLanguageVersion?.name}
                                    title={itemLanguageVersion?.name}
                                    hasNavigationDestination={hasDestinationNavigation}
                                    navigationURL={itemLanguageVersion?.contentRouteNavigationURL}
                                    redirectType={redirectType}
                                    redirectUrl={itemRedirectUrl?.value}
                                    isShowAlways={true}
                                    className="line-clamp-1"
                                />
                            </li>
                        )
                    })
                }
            </ul>
        )
        
    }

    return null;

}

const RenderPages = (props:any) => {

    const pages = usePages({unqKey:props.unqKey, categoryId:props.categoryId});
    
    if ( !pages?.payload || isEmpty(pages.payload) ) return null;

    return (
        <RenderComponent parentLanguageVersion={props.parentLanguageVersion}>
            <RenderItems payload={pages.payload} template={props.template} languageVersionSelector={pageNameDescriptionLanguageVersion} />
        </RenderComponent>
    )
}

const RenderMenuItems = (props:any) => {

    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !isEmpty(menuItems) && menuItems ) {
        return (
            <RenderComponent parentLanguageVersion={props.parentLanguageVersion}>
                <RenderItems payload={menuItems} template={props.template} languageVersionSelector={menuNameDescriptionLanguageVersion} />
            </RenderComponent>
        )
    }

    return null;
}

const MNPG009 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG009.rendered: ", props);
    const [parentLanguageVersion] = useState(outerNameDescriptionLanguageVersion(props.template?.languageVersions));

    if ( !props.template || !props.templates ) return null;

    if ( props.template.isContentChildsMapped ) {
        const childs = props.templates.filter((item) => ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
        if ( !isEmpty(childs) ) {
            return (
                <RenderComponent parentLanguageVersion={parentLanguageVersion} >
                    <RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} />
                </RenderComponent>
            )
        }
    }
    else {
        const mapItem = props.templates.find((item) => item.contentType === EContentType.MAP && item.contentLayoutName?.startsWith("MNGRP_") && item.parentId === props.template?.id);
        if ( mapItem ) {
            return (<RenderMenuItems unqKey={mapItem.id.split("-")[4]} template={mapItem} contentLayoutName={mapItem.contentLayoutName} parentLanguageVersion={parentLanguageVersion} />)
        }

        const categoryItem = props.templates.find((item) => item.contentType === EContentType.CATEGORY && item.parentId === props.template?.id);
        if ( categoryItem ) {
            return (<RenderPages unqKey={categoryItem.id.split("-")[4]} template={categoryItem} categoryId={categoryItem.contentId} parentLanguageVersion={parentLanguageVersion} />)
        }
    }

    return null;
}

const Component = React.memo(MNPG009, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    return true;
});

export default Component;
